// extracted by mini-css-extract-plugin
export default {"resourceCardLayout":"resources_resourceCardLayout__7D7QF"};